module.exports = __webpack_public_path__ + "media/images/icon__point--default@2x-cd8a772ff9147efc50c6cd4d58b8f8ab.png";